import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class UpdateMetadataCurrencyCommand {
    
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(currency_name:string, date:string, document_id:number, user_id:number): Promise<any> {
    let args = { 
        currency_name: currency_name,
        date: date,
        document_id: document_id,
        user_id: user_id
    }
    // test con fecha actual '08/11/2023'
    this.frontend.loading_update_values(true)
    let b = await this.frontend.confirm()
    if(b){
      await this.dispatcher.dispatch('update_with_currency.data', args)
      await this.frontend.fetchDocument({ id: document_id})
      this.frontend.getCurrencyInfo()
    }
    this.frontend.loading_update_values(false)
  }
}